import type { ConstValues } from '@openx/types/helpers.ts';

export const DECIMAL_TO_PERCENT_FACTOR = 100;

export const US_REGION_CODE = 'US';

export const SEGMENT_BUCKETS = ['direct', 'predefined', 'location', 'demographic_age', 'demographic_gender'] as const;

/** `segment.sharing_type` when an owner shares a 1p segment with specific accounts. */
export const SELECTIVE_SHARING = 'SelectiveSharing';

export type AudienceType = ConstValues<typeof AudienceType>;
export const AudienceType = {
  CREATE: 'CREATE',
  BASE: 'BASE',
  USE_DIRECT_AUDIENCE: 'USE_DIRECT_AUDIENCE',
} as const;

export type ExportTypeValue = ConstValues<typeof exportType>;
export const exportType = {
  OA_MATCH: 'oa_match',
  BIDSTREAM: 'bidstream',
  BIDSTREAM_PLUS: 'bidstream_plus',
} as const;

export type MatchingOperator = ConstValues<typeof MatchingOperator>;
export const MatchingOperator = {
  INTERSECTION: 'INTERSECT',
  UNION: 'UNION',
} as const;

export const exportTargetsByType = {
  oa_match: {
    cookie: true,
    ctv: false,
    device: true,
    id5: true,
    idl: true,
    ip: false,
  },
  bidstream_plus: {
    cookie: true,
    ctv: false,
    device: true,
    id5: false,
    idl: true,
    ip: false,
  },
  bidstream: {
    cookie: false,
    ctv: false,
    device: false,
    id5: false,
    idl: false,
    ip: false,
  },
} as const;

export type RevenueMethod = ConstValues<typeof RevenueMethod>;
export const RevenueMethod = {
  CPM: 'CPM',
  PoM: 'PoM',
} as const;
